import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  TextField,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  Box,
  Tooltip,
} from "@mui/material";
import clsx from "clsx";
import { Search, AddCircleOutline } from "@mui/icons-material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ClientSearch(props) {
  const classes = useStyles();

  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(true);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [rows, setRows] = useState([]);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value; // Obtener el valor del input
    setSearchText(value); // Actualizar el estado del texto de búsqueda

    // Filtrar los datos según el valor de búsqueda
    if (value.trim() !== "") {
      const resultSearch = rowsResponse.filter(
        (item) =>
          removeAccents(item.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.email.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.documentId.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          )
      );
      setRows(resultSearch);
    } else {
      setRows(rowsResponse); // Restaurar los datos originales si no hay búsqueda
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setLoader(true);

    try {
      const response = await axios.get(`${urlServices}clients/list`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      });

      if (response.status === 200) {
        // Filtrar solo los elementos cuyo status sea 1
        const filteredData = response.data.filter((data) => data.status === 1);

        // Transformar las filas después de filtrarlas
        const transformedRows = filteredData.map((data) => ({
          ...data,
          prefix: JSON.parse(data.prefix),
        }));

        setRows(transformedRows);
        setRowsResponse(transformedRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const [state] = useState({
    columns: [
      {
        headerName: "Usuario",
        field: "allNames",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Documento",
        field: "documentId",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 50,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Agregar" arrow>
                  <AddCircleOutline style={{ fontSize: 24, color: "green" }} />
                </Tooltip>
              }
              label="Agregar"
              onClick={openSelectValue(params)}
            />
          );

          return actions;
        },
      },
    ],
  });

  const openSelectValue = (data) => () => {
    props.dataSelect(data);

    setTimeout(() => {
      props.exit();
    }, 300);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                <div className={classes.titleCardFilter}>
                  Seleccionar cliente registrado
                </div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              {loader ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} sx={{ m: "8% 0" }}>
                    <center>
                      <img
                        alt="loaderGif"
                        src={loaderGif}
                        style={{ width: 60 }}
                      />
                      <br></br>
                      <b style={{ fontSize: 12 }}>
                        Cargando listado de clientes...
                      </b>
                    </center>
                  </Grid>
                </Grid>
              ) : (
                <Fragment>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      {/* Campo de búsqueda */}
                      <TextField
                        variant="outlined"
                        value={searchText}
                        onChange={handleSearchChange}
                        style={{ marginBottom: 5 }}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <Search
                              position="start"
                              style={{
                                color: "gray",
                                fontSize: 22,
                                marginRight: 10,
                              }}
                            />
                          ),
                        }}
                        sx={{ float: "right", width: 350 }}
                        placeholder="Buscar"
                        helperText="Buscar por NOMBRE, DOCUMENTO o EMAIL"
                      />
                    </Grid>
                    {rows.length > 0 ? (
                      <Grid item xs={12} sm={12}>
                        <Box
                          sx={{
                            "& .super-app.celAll": {
                              fontSize: 12,
                              //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                            },
                            "& .super-app.celActions": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            "& .super-app-theme--header": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            marginTop: 2,
                          }}
                        >
                          <DataGrid
                            rows={rows}
                            columns={state.columns}
                            loading={loader}
                            initialState={{
                              pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                              },
                            }}
                            pageSizeOptions={[5, 10, 20, 50]}
                            disableRowSelectionOnClick={true}
                            checkboxSelection={false}
                            // autoHeights
                            autoWidth
                          />
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item xs={12} sm={12}>
                        <center>
                          <img
                            alt="loaderGif"
                            src={noDataImg}
                            style={{ width: 150, marginTop: 50 }}
                          />
                          <br></br>
                          <b style={{ fontSize: 16, margin: "5px 0 70px 0" }}>
                            No hay registros para mostrar
                          </b>
                        </center>
                      </Grid>
                    )}
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
